<template>
  <v-flex>
    <v-card v-if="useCard" class="elevation-10 mr-4 mt-4">
      <v-card-title class="pb-0">
        <v-flex xs12 class="pb-1 pr-4">
          <h3 class="pr-2">{{ message.subject }}</h3>
        </v-flex>
        <v-flex xs12>
          <h4>From <b>{{ message.from.displayName }}</b></h4>
        </v-flex>
        <v-flex xs12 class="pb-1">
          <h4>Received at <b>{{ receivedAt }}</b></h4>
        </v-flex>
        <v-flex pt-2 pb-2>
          <v-btn color="success" :disabled="!onCaseScreen" class="ma-0  mb-2 mr-2 d-inline-block"
            @click.stop="attachToCase()">
            <v-icon size="20" class="mr-2">create_new_folder</v-icon>
            <span>Attach</span>
          </v-btn>
          <v-btn color="success" class="ma-0  mb-2 d-inline-block" :disabled="!onCaseScreen"
            @click.stop="attachToCaseReturnToCommsroom()">
            <v-icon size="20" class="mr-2" dark>create_new_folder</v-icon>
            <span>Attach & Back to Comms</span>
          </v-btn>
          <v-btn icon class="ma-0 close-panel mb-2" @click.stop="hideSidePanel()">
            <v-icon color="error">cancel</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text class="pt-0 p-relative message-side-panel-iframe">
        <MessageFrame :messageId="this.message.id" />
      </v-card-text>
    </v-card>
    <div v-else>
      <div class="pa-2">
        <h3>{{ message.subject }}</h3>
        <MessageSendStatusPill
          v-if="hasSendStatus"
          class="mb-2"
          :status="message.sendStatus"
          :detail="message.sendStatusDetail"
          :verified-at="message.sendVerifiedAt"
          :updated-at="message.updatedAt"
        />
        <v-btn icon><v-icon>mdi_star</v-icon></v-btn>
        <v-btn icon><v-icon>mdi_cached</v-icon></v-btn>
        <v-btn icon><v-icon>mdi_thumb_up</v-icon></v-btn>
        <v-btn icon @click.stop="hideSidePanel()"><v-icon>mdi_delete</v-icon></v-btn>
        <h3>From <b>{{ message.from.displayName }}</b></h3>
        <h3>Received at <b>{{ receivedAt }}</b></h3>
      </div>
      <MessageFrame :messageId="this.message.id" />
    </div>
  </v-flex>
</template>

<script>
import Helpers from "@/helpers.js"
import { mapState } from "vuex"
import MessageFrame from "@/components/comms/MessageFrame.vue"
import MessageSendStatusPill from "@/components/comms/MessageSendStatusPill.vue"

export default {
  name: "MessageSidePanel",
  components: {
    MessageFrame,
    MessageSendStatusPill
  },
  data: () => ({
    useCard: true,
  }),
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      userPreferences: state => state.currentUser.me.preferences,
      currentUser: state => state.currentUser,
      currentPath: state => state.cbroute.path,
      currentCase: state => state.cases.currentlySelected.case,
      caseIdFromRoute: state => state.cbroute.params.case_id
    }),
    receivedAt() {
      return Helpers.formatTimeAsGmail(new Date(this.message.updatedAt), this.userPreferences.dateFormat)
    },
    hasSendStatus() {
      // Only show send status pill for outbound messages (from.type === "User")
      // Inbound emails (received messages) should not show the send status pill
      if (!this.message || !this.message.sendStatus) {
        return false
      }
      // Check: ensure the message is outbound (from.type === "User")
      // Inbound messages have from.type !== "User" (e.g., "Custom" for external senders)
      if (!this.message.from || this.message.from.type !== "User") {
        return false
      }
      // Show for outbound messages with valid statuses
      return true
    },
    onCaseScreen() {
      return this.currentPath && !!this.currentPath.match(/\/case\/\d+/)
    },
    selectedCaseId() {
      if (this.caseIdFromRoute !== undefined && this.caseIdFromRoute !== null && this.caseIdFromRoute !== "") {
        return "" + this.caseIdFromRoute
      }
      if (this.currentCase && this.currentCase.id !== undefined && this.currentCase.id !== null && this.currentCase.id !== "") {
        return "" + this.currentCase.id
      }
      return null
    }
  },
  onBeforeMount() {
    this.$store.dispatch("hideSidePanel")
  },
  onBeforeUnmount() {
    this.$store.dispatch("resetSidePanel")
  },
  methods: {
    hideSidePanel() {
      this.$store.dispatch("hideSidePanel")
    },
    async attachToCase() {
      const ids = { conversationId: parseInt(this.message.conversation.id, 10), caseId: this.selectedCaseId }
      await this.$store.dispatch("attachConversationToCase", ids)
      if (this.selectedCaseId) {
        await this.$store.dispatch("getCurrentlySelectedCase", { caseId: this.selectedCaseId })
      }
      this.hideSidePanel()
    },
    async attachToCaseReturnToCommsroom() {
      const ids = { conversationId: parseInt(this.message.conversation.id, 10), caseId: this.selectedCaseId }
      await this.$store.dispatch("attachToCaseReturnToCommsroom", ids)
      this.hideSidePanel()
    },
  }
}
</script>
<style>
.close-panel {
  position: absolute !important;
  top: 10px;
  right: 10px;
}

.message-side-panel-iframe iframe {
  height: calc(100vh - 330px) !important;
}

.with-summary .message-side-panel-iframe iframe {
  height: calc(100vh - 390px) !important;
}
</style>